import { render, staticRenderFns } from "./ScanHistoryComp.vue?vue&type=template&id=fcc1843a&scoped=true&"
import script from "./ScanHistoryComp.vue?vue&type=script&lang=js&"
export * from "./ScanHistoryComp.vue?vue&type=script&lang=js&"
import style0 from "./ScanHistoryComp.vue?vue&type=style&index=0&id=fcc1843a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc1843a",
  null
  
)

export default component.exports